import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEOHead — Adds page-specific meta tags for SEO.
 * Usage: <SEOHead title="Cricket Betting" description="..." />
 */
const SEOHead = ({ title, description, keywords, url, type = 'website' }) => {
  const fullTitle = title ? `${title} | Reddy Anna Book` : 'Reddy Anna Book - Best Online Cricket Betting Exchange in India';
  const fullDesc = description || "Reddy Anna Book is India's most trusted online betting exchange. Bet on Cricket, IPL, Football, Casino games. Get ₹50 welcome bonus.";
  const fullUrl = url ? `https://reddyannabook.me${url}` : 'https://reddyannabook.me';
  const fullKeywords = keywords || 'Reddy Anna Book, reddy anna book betting exchange, online betting India, cricket betting exchange';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDesc} />
      <meta name="keywords" content={fullKeywords} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDesc} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDesc} />
    </Helmet>
  );
};

export default SEOHead;
